import { ReactElement } from 'react'
import { BackButton, Loader, PageWrapper } from '../../../../components'
import { useHistory } from 'react-router-dom'
import { CardWrapper } from '../subcomponents'
import { FlexWrapper, Column } from '../../../../components'
import strings from '../../../../locale/en'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'
import { RootState } from '../../../../redux/store'
import { resetBranch } from '../../../../redux/coachingCenter/actions'
import { DATE_FORMAT_MMDDYYYY } from '../../../../const/dateFormat'
import format from 'date-fns/format'
import { Session } from '../../../../redux/session/types'

const SessionDetail = (): ReactElement => {
  const { isLoading, session } = useSelector(
    (state: RootState) => ({
      isLoading: state.session.isLoading,
      session: state.session.selectedSession as Session
    }),
    shallowEqual
  )

  const dispatch = useDispatch()
  const history = useHistory()
  const {
    sessionDetails: {
      sessionNameLabel,
      topicLabel,
      subjectNameLabel,
      courseNameLabel,
      batchLabel,
      branchNameLabel,
      instituteLabel,
      dateLabel,
      startTimeLabel,
      endTimeLabel,
      statusLabel
    }
  } = strings

  const {
    sessionName,
    topicName,
    batchList,
    branchList,
    coachingCentre,
    sessionDate,
    startTime,
    endTime,
    subject,
    status,
    course
  } = session || {}

  return isLoading ? (
    <Loader />
  ) : (
    <PageWrapper id="container">
      <div>
        <BackButton
          handleBack={() => {
            dispatch(resetBranch())
            history.goBack()
          }}
        />
      </div>
      <FlexWrapper justifyContent="space-around">
        <CardWrapper>
          <Column keyName={sessionNameLabel} value={sessionName} />
          <Column keyName={topicLabel} value={topicName} />
          <Column keyName={subjectNameLabel} value={subject?.courseName} />
          <Column keyName={courseNameLabel} value={course?.courseName} />
          <Column keyName={batchLabel}>
            {batchList.map(({ batchName }, index) => (
              <div key={`batch-${index}`}>{batchName}</div>
            ))}
          </Column>
          <Column keyName={branchNameLabel}>
            {branchList.map(({ branchName }, index) => (
              <div key={`branch-${index}`}>{branchName}</div>
            ))}
          </Column>
        </CardWrapper>
        <CardWrapper>
          <Column
            keyName={instituteLabel}
            value={coachingCentre?.coachingCentreName}
          />
          <Column
            keyName={dateLabel}
            value={format(new Date(sessionDate), DATE_FORMAT_MMDDYYYY)}
          />
          <Column keyName={startTimeLabel} value={startTime} />
          <Column keyName={endTimeLabel} value={endTime} />
          <Column keyName={statusLabel} value={status} />
        </CardWrapper>
      </FlexWrapper>
    </PageWrapper>
  )
}

export default SessionDetail
